var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Dependencies, Layout } from "~/core/decorator";
import { PageService } from "~/utils/page.service";
import { SortService } from "~/utils/sort.service";
import NumberRange from "~/components/common/number-range.vue";
import { namespace } from "vuex-class";
import { CASE_CHANNEL, MENU_CHANNEL } from "~/config/enum.config";
import { SynthesizeQueryService } from "~/services/domain-service/synthesize-query.service";
import GetLabelName from "~/components/labeling-strategy/get-label-name.vue";
var CollectionExecutionModule = namespace("collection-execution");
var InBoundQuery = /** @class */ (function (_super) {
    __extends(InBoundQuery, _super);
    function InBoundQuery() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.caseType = CASE_CHANNEL.tel;
        _this.booleanValue = false;
        _this.model = {
            caseNumber: "",
            personalName: "",
            mobileNo: "",
            idCard: "",
            currentCollectorRealName: "",
            collectionStatus: "",
            overdueAmount: {
                max: "",
                min: ""
            },
            caseMoney: { min: "", max: "" },
            overduePeriod: "",
            overdueDays: {
                max: "",
                min: ""
            },
            area: "",
            labelName: []
        };
        _this.dataSet = [];
        return _this;
    }
    InBoundQuery.prototype.mounted = function () {
        // this.refreshData()
    };
    InBoundQuery.prototype.activated = function () {
        var _this = this;
        if (this.caseId) {
            this.synthesizeQuerService
                .bindLockingCollector(this.caseId)
                .subscribe(function (data) {
                setTimeout(function () {
                    _this.refreshData();
                }, 100);
            });
        }
    };
    InBoundQuery.prototype.inBoundQuery = function () {
        var _this = this;
        var exists = Object.values(this.model).filter(function (x) {
            if (x instanceof Object) {
                return !!Object.values(x).filter(function (sub) { return !!sub; }).length;
            }
            else if (Array.isArray(x)) {
                return !!x.filter(function (array) { return !!array; }).length;
            }
            else {
                return !!x;
            }
        });
        if (!exists.length) {
            this.$message.warning("请输入至少一项查询条件");
            return;
        }
        this.synthesizeQuerService
            .inboundQuery(this.model, this.pageService, this.sortService)
            .subscribe(function (data) { return (_this.dataSet = data); });
    };
    InBoundQuery.prototype.refreshData = function () {
        this.inBoundQuery();
    };
    /**
     * 表单范围输入框重置
     */
    InBoundQuery.prototype.handleResetForm = function () {
        this.model.overdueAmount = { min: "", max: "" };
        this.model.overdueDays = { min: "", max: "" };
        this.model.caseMoney = { min: "", max: "" };
    };
    /**
     * 进入查看执行页
     */
    InBoundQuery.prototype.openExecutionPage = function (row) {
        this.caseId = row.id;
        var hiddenAction = false;
        //控制打开催收页类别
        if (row.collectionType === "TEL" &&
            (row.collectionStatus === "INNER_COLLECTING" ||
                row.collectionStatus === "INNER_WAIT_DISTRIBUTE")) {
            this.caseType = CASE_CHANNEL.tel;
        }
        else if (row.collectionType === "TEL" &&
            row.collectionStatus !== "INNER_COLLECTING" &&
            row.collectionStatus !== "INNER_WAIT_DISTRIBUTE") {
            this.caseType = CASE_CHANNEL.tel;
            hiddenAction = true;
        }
        else if (row.collectionType === "VISIT" &&
            (row.collectionStatus === "INNER_COLLECTING" ||
                row.collectionStatus === "INNER_WAIT_DISTRIBUTE")) {
            this.caseType = CASE_CHANNEL.visit;
        }
        else if (row.collectionType === "VISIT" &&
            row.collectionStatus !== "INNER_COLLECTING" &&
            row.collectionStatus !== "INNER_WAIT_DISTRIBUTE") {
            this.caseType = CASE_CHANNEL.visit;
            hiddenAction = true;
        }
        this.$router.openCaseDetail(row.id, {
            menuChannel: MENU_CHANNEL.NONE,
            hiddenCaseList: true,
            hiddenAction: true
        });
    };
    Object.defineProperty(InBoundQuery.prototype, "collectionStatus", {
        //过滤案件状态类型
        get: function () {
            var enableCollectionStatus = [
                "INNER_COLLECTING",
                "INNER_BANKC",
                "INNER_PAYOFF"
            ];
            return this.$dict
                .getDictData("CollectionStatus")
                .filter(function (v) { return enableCollectionStatus.includes(v.code); });
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        Dependencies(PageService)
    ], InBoundQuery.prototype, "pageService", void 0);
    __decorate([
        Dependencies(SortService)
    ], InBoundQuery.prototype, "sortService", void 0);
    __decorate([
        Dependencies(SynthesizeQueryService)
    ], InBoundQuery.prototype, "synthesizeQuerService", void 0);
    __decorate([
        CollectionExecutionModule.Action
    ], InBoundQuery.prototype, "openCollectionExecution", void 0);
    __decorate([
        CollectionExecutionModule.Mutation
    ], InBoundQuery.prototype, "updateCollectionSign", void 0);
    InBoundQuery = __decorate([
        Layout("workspace"),
        Component({
            components: {
                GetLabelName: GetLabelName,
                NumberRange: NumberRange
            }
        })
    ], InBoundQuery);
    return InBoundQuery;
}(Vue));
export default InBoundQuery;
